<template>
  <div class="main-body pb-10">
    <div v-for="(item,index) in list" :key="item.id" class="transition duration-500 bg-white border-gray-100 border-2 hover:border-0 rounded-xl hover:shadow-lg mt-4 transform hover:-translate-y-1 p-6">
      <router-link :to="{'path':'/pages/web/course','query':{'id':item.id}}">
        <div class="flex">
          <div>
            <el-image class="w-32 rounded" :src="item.thumb">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
          <div class="pl-4">
            <p>
              <el-tag>标签一</el-tag>
              <span class="ml-2">{{ item.name }}</span>
            </p>
            <div class="mt-4 text-sm text-gray-400">
              上次学到：{{item.last}}
            </div>
            <div class="mt-2 text-red-600">
              <el-progress :percentage="item.percent" text-color="red" :stroke-width="8"></el-progress>
            </div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: "login",
  /**
   * 调用组建
   * @type {Object}
   */
  components: {},
  /**
   * 组建属性
   * @type {Object}
   */
  props: {},
  /**
   * 数据字段
   * @return {[type]} [description]
   */
  data() {
    return {
      list:[]
    };
  },
  /**
   * 计算属性
   * @type {Object}
   */
  computed: {},
  /**
   * 数据监听
   * @type {Object}
   */
  watch: {},
  /**
   * 页面创建时
   * @return {[type]} [description]
   */
  created() {

  },
  /**
   * 页面加载时
   * @return {[type]} [description]
   */
  mounted() {
    this.getData()
  },
  /**
   * 页面调用函数
   * @type {Object}
   */
  methods: {
    getData(){
      this.$cloud.get('/history/list').then(res=>{
        console.log("历史列表",res)
        this.list = res
      })
    }
  }
};
</script>
<style scoped>

</style>
